import { Component } from '@angular/core';

@Component({
    selector: 'xp-footer',
    template: `
        <footer class="mt++">
            <hr />
            <p>© Made with ♥ by the DevLabs team.</p>
        </footer>
    `,
    styles: []
})
export class FooterComponent {

    constructor() { }

}



// WEBPACK FOOTER //
// ./src/app/shared/footer.component.ts